// modules
import { createSelector } from 'reselect'
// constants
import { MODULE_LIST } from 'src/constants'

const gamification = (state) => state.company.gamification
const profile = (state) => state.user.profile

export const achievementsList$ = createSelector(
  gamification,
  (gamification) => gamification.achievementsList
)

export const tasksList$ = createSelector(
  gamification,
  (gamification) => gamification.tasksList
)

export const shopItemsList$ = createSelector(
  gamification,
  (gamification) => gamification.shopItems
)

export const redemptionList$ = createSelector(
  gamification,
  (gamification) => gamification.redemptionList
)

export const gamificationEnable$ = createSelector(
  profile,
  ({ licenseModule = [] }) =>
    !!licenseModule.filter((item) => item.name === MODULE_LIST.gamification)
      .length
)

export const gamificationLoading$ = (loader) =>
  createSelector(gamification, (gamification) => gamification.loading[loader])

export const redemptionItemHistory$ = createSelector(
  gamification,
  (gamification) => gamification.redemptionItemHistory
)

export const redemptionBadgeCount$ = createSelector(
  gamification,
  ({ redemptionBadgeCount }) => redemptionBadgeCount
)
